import { memo } from 'react';
import { EditableCell } from './EditableCell';
import type { Project } from '@/api/client';

interface TracksCountCellProps {
  project: Project;
}

export const TracksCountCell = memo(function TracksCountCell({ project }: TracksCountCellProps) {
  const value = project.tracks_count;

  const display = value != null ? (
    <div className="projects-table__base-cell">
      <strong>{value}</strong>
    </div>
  ) : null;

  return (
    <EditableCell project={project} fieldKey="tracks_count">
      {display ?? <span className="projects-table__empty-value">N/A</span>}
    </EditableCell>
  );
});
